import React, { useState } from 'react';
import { Box } from 'rebass';
import SbEditable from 'storyblok-react';
import Helmet from 'react-helmet';

import Header from '../../navigation/Header/Header';
import Footer from '../../navigation/Footer/Footer';
import Navigation from '../../navigation/Navigation/Navigation';
import CookieNotice from '../CookieNotice/CookieNotice';
import { TypographyContextProvider } from '../Typography/Typography';

import GlobalStyles from '../../styles/GlobalStyles';
import { LayoutStoryblok } from '../../types/storyblok';
import { HeaderAnnouncement } from "../../navigation/Header/components/HeaderAnnouncement/HeaderAnnouncement";

const Layout = ({
  children,
  content,
  locale,
  headerColourScheme = 'white',
  footerColourScheme = 'white',
  overlayFooterOverBkg = false,
}: LayoutStoryblok) => {
  const [menuVisible, setMenuVisible] = useState(0);
  const items = new Map((content?.items || []).map((i) => [i.component, i]));
  const announcement = items.get('Announcement');
  const headerAnnouncement = items.get('HeaderAnnouncement')
  return (
    <TypographyContextProvider>
      <GlobalStyles />
      <Helmet>
        <html lang={locale || 'en'} />
      </Helmet>
      <Box
        width={1}
        mx="auto"
        className="body"
        style={{ position: 'relative' }}
      >
        <SbEditable content={content}>
          {!!headerAnnouncement && <HeaderAnnouncement {...headerAnnouncement} />}
          <Header
            colourScheme={headerColourScheme}
            menuToggleFunction={() => setMenuVisible(!menuVisible)}
            {...items?.get('Header')}
          />
          <main>{children ? children : null}</main>

          <Footer
            colourScheme={footerColourScheme}
            overlayOverBkg={overlayFooterOverBkg}
            {...items?.get('Footer')}
          />
        </SbEditable>
      </Box>
      <CookieNotice />
    </TypographyContextProvider>
  );
};

export default Layout;
